<template>
  <div style="margin-top: 0.2rem">
    <div class="flex justify-center items-center">
      <svg-icon
        slot="left-icon"
        style="
          width: 0.1rem;
          height: 0.1rem;
          transform: rotate(45deg);
          color: var(--theme-color-line);
        "
        classNameQita
        icon-class="icon-square-two"
      />
      <svg-icon
        slot="left-icon"
        style="
          width: 0.15rem;
          height: 0.15rem;
          transform: rotate(45deg);
          color: var(--theme-color-line);
          margin-left: 0.05rem;
        "
        classNameQita
        icon-class="icon-square-one"
      />
      <div class="title">{{ $t('common.title1') }}</div>
      <svg-icon
        slot="left-icon"
        style="
          width: 0.15rem;
          height: 0.15rem;
          transform: rotate(45deg);
          color: var(--theme-color-line);
        "
        classNameQita
        icon-class="icon-square-one"
      />
      <svg-icon
        slot="left-icon"
        style="
          width: 0.1rem;
          height: 0.1rem;
          transform: rotate(45deg);
          color: var(--theme-color-line);
          margin-left: 0.05rem;
        "
        classNameQita
        icon-class="icon-square-two"
      />
    </div>
    <div style="width: calc(100% - 0.4rem); margin: 0 0.2rem; overflow: hidden">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in $store.state.special_game"
          >
            <gameItem
              :item="item"
              type="home"
              :key="index"
              :isLazy="false"
            ></gameItem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gameItem from '@/components/gameItem/index_swiper.vue';
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css'; // 注意这里的引入
export default {
  components: {
    gameItem
  },
  props: {},
  data() {
    return {
      list: [
        {
          id: 2,
          category: 'slot',
          name: 'PG Slots',
          code: 'pg',
          image: 'https://img.hermes-game.com/uploads/cate/nav_05/left/pg.png',
          type: 'platform'
        }
      ]
    };
  },
  mounted() {
    let space = this.convertEmToPx(0.25);
    var swiper = new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 5,
      centeredSlides: true,
      spaceBetween: space,
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true // 修改swiper父元素时，自动初始化swiper
    });
  },
  methods: {
    convertEmToPx(emValue) {
      const fontSize = parseFloat(
        window.getComputedStyle(document.documentElement).fontSize
      );
      return emValue * fontSize;
    }
  }
};
</script>
<style scoped>
.title {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 3.74rem;
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 0.24rem;
  margin: 0 0.14rem;
  color: #fff;
}
.swiper-container {
  padding: 0.3rem 0 0.25rem 0;
  margin-left: -0.9rem;
  width: calc(100% + 1.8rem);
}

.swiper-slide {
  transition: 500ms;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  transform: scale(0.9);
  height: auto !important;
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1.1);
}

.swiper-slide-prev,
.swiper-slide-duplicate-prev,
.swiper-slide-next,
.swiper-slide-duplicate-next {
  transform: scale(1);
}
.swiper-slide-prev,
.swiper-slide-duplicate-prev {
  .game_item {
    margin-left: -0.15rem;
  }
}
.swiper-slide-next,
.swiper-slide-duplicate-next {
  .game_item {
    margin-left: 0.15rem;
  }
}
</style>
